module.exports = __webpack_public_path__ + "static/report/img/logo.64eda035.jpg";